import clsx from 'clsx'
import {useMetric} from '../../core/MetricProvider'
import {MetricProduct} from '../../core/_models'
import {formatMoney, formatNumber, formatPercent} from '../../core/_format'
import {useTableSort} from '../../core/useTableSort'

type SortKey = keyof MetricProduct

const COLUMNS: Array<{key: SortKey; title: string; className?: string}> = [
  {key: 'code', title: 'Código'},
  {key: 'label', title: 'Produto', className: 'min-w-150px'},
  {key: 'sessions', title: 'Sessões vendidas', className: 'text-end'},
  {key: 'sessionsRealized', title: 'Sessões realizadas', className: 'text-end'},
  {key: 'sessionsPending', title: 'Sessões não realizadas', className: 'text-end'},
  {key: 'amount', title: 'Valor faturado', className: 'text-end'},
  {key: 'share', title: 'Participação no faturamento', className: 'text-end'},
]

const ProductsTab = () => {
  const {products} = useMetric()
  const {rows, toggleSort, sortClass} = useTableSort(products?.products ?? [])

  if (!products) {
    return null
  }

  const {total} = products

  return (
    <div className='table-responsive'>
      <table className='table align-middle table-row-dashed fs-6 gy-4'>
        <thead>
          <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
            {COLUMNS.map((column) => (
              <th
                key={column.key}
                className={clsx(column.className, sortClass(column.key))}
                style={{cursor: 'pointer'}}
                onClick={() => toggleSort(column.key)}
              >
                {column.title}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className='text-gray-600 fw-bold'>
          {rows.map((product) => (
            <tr key={product.code}>
              <td>{product.code}</td>
              <td>{product.label}</td>
              <td className='text-end'>{formatNumber(product.sessions)}</td>
              <td className='text-end'>{formatNumber(product.sessionsRealized)}</td>
              <td className='text-end'>{formatNumber(product.sessionsPending)}</td>
              <td className='text-end'>{formatMoney(product.amount)}</td>
              <td className='text-end'>{formatPercent(product.share)}</td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr className='fw-bolder text-gray-800 border-top border-gray-300'>
            <td colSpan={2}>TOTAL</td>
            <td className='text-end'>{formatNumber(total.sessions)}</td>
            <td className='text-end'>{formatNumber(total.sessionsRealized)}</td>
            <td className='text-end'>{formatNumber(total.sessionsPending)}</td>
            <td className='text-end'>{formatMoney(total.amount)}</td>
            <td className='text-end'>{formatPercent(total.share)}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  )
}

export {ProductsTab}
